import * as React from 'react';
import { jsx, css } from '@emotion/react';
import type { answerWithImageType } from '../../views/types';
import type { SectionsPropsType } from '../types';
import { renderAdvisorMessage } from '../../views/AdvisorMessage';
import { renderUserMessage } from '../../views/UserMessage';
import { renderRadioLikeButtonGroupWithImage } from '../../views/RadioLikeButtonGroupWithImage';
import { buildAnswers, buildUserAnswerMessage } from '../utils';

import WallMaterialMortarPngPath from 'Images/me/pages/guest/proposals/new/wall_material/mortar.png'
import WallMaterialMortarWebPPath from 'Images/me/pages/guest/proposals/new/wall_material/mortar.webp'
import WallMaterialSidingPngPath from 'Images/me/pages/guest/proposals/new/wall_material/siding.png'
import WallMaterialSidingWebPPath from 'Images/me/pages/guest/proposals/new/wall_material/siding.webp'
import WallMaterialTilesPngPath from 'Images/me/pages/guest/proposals/new/wall_material/tiles.png'
import WallMaterialTilesWebPPath from 'Images/me/pages/guest/proposals/new/wall_material/tiles.webp'
import WallMaterialAlcPngPath from 'Images/me/pages/guest/proposals/new/wall_material/alc.png'
import WallMaterialAlcWebPPath from 'Images/me/pages/guest/proposals/new/wall_material/alc.webp'

const SECTION_KEY_NAME = 'wallMaterial';
const PARAM_NAME = SECTION_KEY_NAME;
const GA_EVENT_NAME = 'wallMaterial';

export const wallMaterialSection = async (props: SectionsPropsType) => {
  const { userAnswers, commonAnswerHandler } = props;
  const answers: answerWithImageType[] = [
    {
      value: 'モルタル',
      imagePaths: {
        imagePath: WallMaterialMortarPngPath,
        webp: WallMaterialMortarWebPPath,
      }
    },
    {
      value: 'サイディング',
      imagePaths: {
        imagePath: WallMaterialSidingPngPath,
        webp: WallMaterialSidingWebPPath,
      }
    },
    {
      value: 'タイル',
      imagePaths: {
        imagePath: WallMaterialTilesPngPath,
        webp: WallMaterialTilesWebPPath,
      }
    },
    {
      value: 'ALC',
      imagePaths: {
        imagePath: WallMaterialAlcPngPath,
        webp: WallMaterialAlcWebPPath,
      }
    },
    {
      value: 'その他',
      imagePaths: null
    },
    {
      value: 'わからない',
      imagePaths: null
    },
  ];
  const answerHandler = (event: React.MouseEvent<HTMLButtonElement>): void => {
    const { textContent, value } = event.currentTarget;

    commonAnswerHandler(PARAM_NAME, textContent || '');

    userAnswers.push({
      keyName: SECTION_KEY_NAME,
      paramName: PARAM_NAME,
      question: '今の外壁材は',
      answer: textContent || '',
      value: value || '',
    });
  };

  // アドバイザーの吹き出し
  await renderAdvisorMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    isVisibleAvatar: true,
    messageElement: (
      <>
        現在の外壁材はどのようなものをお使いですか？
      </>
    ),
  });

  // 回答ボタン表示
  const answer = await renderRadioLikeButtonGroupWithImage({
    ...props,
    keyName: SECTION_KEY_NAME,
    answers: buildAnswers({
      keyName: SECTION_KEY_NAME,
      answers,
      answerHandler,
      gaEventName: GA_EVENT_NAME,
    }),
  });

  // ユーザーの吹き出し
  await renderUserMessage({
    ...props,
    keyName: SECTION_KEY_NAME,
    messageElement: buildUserAnswerMessage(answer.answerText),
  });

  // 回答内容を返却する
  return answer;
};
